<template>
  <div class="layout">
    <shop-header />

    <shop-content class="body"></shop-content>

    <shop-footer />

    <loading
      class="loading"
      ref="loading"
    />
  </div>
</template>

<script>
import ShopHeader from './Header.vue'
import ShopContent from './Content.vue'
import ShopFooter from './Footer.vue'
import Loading from '@/components/common/Loading.vue'
// import { db } from '@/assets/js/firestore.js'

export default {
  components: {
    ShopHeader,
    ShopContent,
    ShopFooter,
    Loading
  },
  data: function () {
    return {
      unsubscribe: null,
      LatestOrderTime: 0
    }
  },
  mounted () {
    // this.setupOrderAlert(this.$route.params.shopid)
    // this.$eventHub.$on('setup-orderalert', this.setupOrderAlert)
    this.$eventHub.$on('open-loading', this.$refs.loading.open)
    this.$eventHub.$on('close-loading', this.$refs.loading.close)
  },
  beforeDestroy () {
    this.$eventHub.$off('open-loading')
    this.$eventHub.$off('close-loading')
  },
  methdos: {
    // setupOrderAlert (shopid) {
    //   debugger
    //   if (shopid) {
    //     if (this.unsubscribe) {
    //       this.unsubscribe()
    //       this.LatestOrderTime = 0
    //     }
    //     this.unsubscribe = db.collection('restaurant').doc(this.shopid.toString()).onSnapshot((doc) => {
    //       let _data = doc.data()
    //       if (_data.LatestOrderTime.seconds > this.LatestOrderTime) {
    //         this.LatestOrderTime = _data.LatestOrderTime.seconds
    //         console.log('alert')
    //       }
    //     })
    //   }
    // }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/shop.scss";
</style>
<style lang="scss" scoped>
.layout {
  margin: 0px;
  padding: 0px;
  position: relative;
  header {
    height: 2rem;
    margin: 0 auto;
  }
  .body {
    min-height: calc(100vh - 3rem);
  }
  footer {
    margin: 0 auto;
  }
  .loading {
    width: 100vw;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shop/Layout.vue